<template>
  <div>
    <view-table
        ref="viewTable"
        :limits="limits"
        :filter="filter"
        :columns-property="columnsProperty"
        module="basic"
        url="inStockBillBacks"
        @reset="resetHandle"
        @delete="deleteHandle"
        @select="selectHandle"
        @addOrEdit="addEditHandle">
      <template slot="otherBtn">
        <el-button v-if="submitAuth" type="primary" :disabled="!selection.length" @click="submit"> 提交</el-button>
        <el-button v-if="cancelAuth" type="primary" :disabled="!selection.length" @click="repeal"> 撤销</el-button>
        <el-button v-if="printAuth" type="primary" :disabled="!selection.length" @click="printOutStockOrder()">
          打印退料单
        </el-button>
        <el-button v-if="delAllAuth" type="danger" :disabled="!selection.length" @click="deleteBatch"> 批量删除</el-button>
      </template>
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" label-width="65px" @keyup.enter.native="loadData(1)">
          <el-form-item label="退料单号">
            <el-input v-model.trim="filter.billNo" placeholder="请输入退料单号" clearable/>
          </el-form-item>
          <el-form-item label="退料状态">
            <el-select v-model="filter.status" clearable placeholder="请选择退料状态">
              <el-option label="草稿" :value="0"/>
              <el-option label="待确认" :value="1"/>
              <el-option label="已完成" :value="2"/>
            </el-select>
          </el-form-item>
          <el-form-item label="关联单据">
            <el-input v-model.trim="filter.relBillNo" placeholder="请输入关联单据编号" clearable/>
          </el-form-item>
          <el-form-item label="制单人">
            <el-input v-model.trim="filter.creatorName" placeholder="请输入" clearable/>
          </el-form-item>
          <!--          <el-form-item label="要求日期">-->
          <!--            <el-date-picker-->
          <!--                v-model="requireDateRange"-->
          <!--                type="daterange"-->
          <!--                range-separator="至"-->
          <!--                start-placeholder="开始时间"-->
          <!--                end-placeholder="结束时间"-->
          <!--                value-format="yyyy-MM-dd"-->
          <!--                @change="dateRangeChange('requireDateRange', 'requireDateBegin', 'requireDateEnd')"/>-->
          <!--          </el-form-item>-->
          <el-form-item label="制单日期">
            <el-date-picker
                v-model="createDateRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd"
                @change="dateRangeChange('createDateRange', 'createDateFrom', 'createDateTo')"/>
          </el-form-item>
        </el-form>
      </template>
    </view-table>
    <production-return-edit ref="editPage" @save-success="loadData(1)"/>
    <print-production-return ref="printOutStockOrder"/>
  </div>
</template>

<script>
  import ViewTable from "@/components/ViewTable.vue";
  import ProductionReturnEdit from "./ProductionReturnEdit";
  import printProductionReturn from "./PrintProductionReturn";

  export default {
    name: "ProductionReturnList",
    components: {ViewTable, ProductionReturnEdit, printProductionReturn},
    data() {
      return {
        ids: [],
        selection: [],
        requireDateRange: [],
        createDateRange: [],
        limits: {
          addAuth: this.$auth(372),
          delAuth: this.$auth(377),
          editAuth: this.$auth(378),
        },
        detailAuth: this.$auth(376),
        delAllAuth: this.$auth(377),
        printAuth: this.$auth(375),
        submitAuth: this.$auth(373),
        cancelAuth: this.$auth(374),
        searchShow: false,
        OutStorageDate: "",
        createDate: "",
        filter: {
          billNo: "",
          status: 1,
          relBillNo: "",
          // requireDateBegin:"",
          // requireDateEnd:"",
          createDateFrom: "",
          createDateTo: "",
          creatorName: "",
        },
        columnsProperty: [
          {
            key: "billNo",
            align: "center",
            minWidth: 140,
            render: (h, params) => {
              return h(
                  "span",
                  {
                    style: {
                      color: "#2d8cf0",
                      cursor: "pointer",
                    },
                    on: {
                      click: () => {
                        if (this.detailAuth) {
                          this.$refs.editPage.open(params.row, true);
                        }
                      },
                    },
                  },
                  params.row.billNo,
              );
            },
          },
          {
            key: "action",
            align: "center",
            width: 140,
            slot: "action",
            fixed: "right",
          },
        ],
      };
    },

    watch: {
      // "filter.requireDateBegin": {
      //   handler(newVal) {
      //     if (newVal) {
      //       this.requireDateRange = [];
      //       this.requireDateRange.push(this.filter.requireDateBegin);
      //       this.requireDateRange.push(this.filter.requireDateEnd);
      //     }
      //   },
      // },
      "filter.createDateFrom": {
        handler(newVal) {
          if (newVal) {
            this.createDateRange = [];
            this.createDateRange.push(this.filter.createDateFrom);
            this.createDateRange.push(this.filter.createDateTo);
          }
        },
      },
    },
    methods: {
      // 查询
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },
      dateRangeChange(timeRange, timeStart, timeEnd) {
        if (this[timeRange]) {
          this.filter[timeStart] = this[timeRange][0];
          this.filter[timeEnd] = this[timeRange][1];
        } else {
          this.filter[timeStart] = "";
          this.filter[timeEnd] = "";
        }
      },
      addEditHandle(row) {
        this.$refs.editPage.open(row);
      },

      selectHandle(selection) {
        this.ids = [];
        this.selection = selection;
        this.selection.forEach((item) => {
          this.ids.push(item.pkid);
        });
      },

      // 提交
      submit() {
        const arr = this.selection.filter((item) => item.status !== 0);
        if (arr.length) {
          this.$confirm("请选择未提交的订单", "错误", {
            type: "error",
            showCancelButton: false,
          });
        } else {
          this.$confirm("确定提交吗?", "提示", {type: "warning"}).then(() => {
            this.$http.post("basic", "inStockBillBacks/submit", this.ids).then(() => {
              this.loadData(1);
              this.$message.success("提交成功");
              this.selection = [];
            });
          });
        }
      },

      // 撤销
      repeal() {
        const arr = this.selection.filter((item) => item.status !== 1);
        if (arr.length) {
          this.$confirm("请选择已提交的订单", "错误", {
            type: "error",
            showCancelButton: false,
          });
        } else {
          this.$confirm("确定撤销吗?", "提示", {type: "warning"}).then(() => {
            this.$http.post("basic", "inStockBillBacks/cancel", this.ids).then(() => {
              this.loadData(1);
              this.$message.success("撤销成功");
              this.selection = [];
            });
          });
        }
      },

      // 打印退料单
      printOutStockOrder() {
        const arr = this.selection.filter((item) => item.status == 0);
        if (arr.length) {
          this.$confirm("请选择已提交或已出库的订单", "错误", {
            type: "error",
            showCancelButton: false,
          });
          return;
        }
        this.$refs.printOutStockOrder.open(this.ids);
      },

      // 单个删除
      deleteHandle(row) {
        this.$http.delete("basic", "inStockBillBacks", row.pkid).then((resp) => {
          if (resp.success) {
            this.loadData(1);
            this.$message.success("删除成功");
            this.selection = [];
          }
        });
      },

      // 批量删除
      deleteBatch() {
        const arr = this.selection.filter((item) => item.status !== 0);
        if (arr.length) {
          this.$confirm("请选择未提交状态的订单", "错误", {
            type: "error",
            showCancelButton: false,
          });
          return;
        }
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          this.$http.post("basic", "inStockBillBacks/deleteBatch", this.ids).then((resp) => {
            if (resp.success) {
              this.loadData(1);
              this.$message.success("删除成功");
              this.selection = [];
            }
          });
        });
      },

      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
      },

      otherAuth(row) {
        if (row.status === 1 || row.status === 2) {
          return {
            editAuth: true,
          };
        } else {
          return {
            editAuth: false,
          };
        }
      },
    },
  };
</script>
